export default "__VITE_ASSET__BKg9qmmf__"